export function exactMoney(value) {
  if(value==null)return 'Belum tersedia';
  const text=String(value);
  if(!/^-?\d+(\.\d+)?$/.test(text))return 'Belum tersedia';
  const [whole,fraction]=text.split('.');
  return 'Rp '+whole.replace(/\B(?=(\d{3})+(?!\d))/g,'.')+(fraction?','+fraction:'');
}

// B-473: a stored figure has an exact decimal-string twin (`<field>_exact`). Show the twin when it exists —
// formatted from the string, never through a JavaScript number, which cannot hold 9007199254740993.00 or
// 999999999999999.99 — and the legacy number only for records written before the twin existed.
export function moneyOf(exactValue, legacyNumber, rupiah) {
  if (exactValue != null && exactValue !== "") return exactMoney(exactValue);
  if (legacyNumber == null) return "-";
  return rupiah ? rupiah(legacyNumber) : String(legacyNumber);
}
